/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

function musaMainVariantRoot() {
  return document.querySelector(
    'variant-radios:not([data-card]), variant-mixed-inputs:not([data-card]), variant-selects:not([data-card])'
  );
}

/* =========================================================================
   MUSA 1 - Preselection de la taille 100x75, version PILOTEE PAR LES DONNEES

   Historique : la v1 pilotait l'interface par .click() programmatiques en
   boucle (balayage des profondeurs avec attentes de 450 ms). Elle a ete
   DESARMEE le 29/07/2026 apres un gel signale en production — les clics
   simules en rafale etaient le premier suspect.

   Cette version ne clique rien et ne boucle pas : elle lit le JSON de
   variantes que le theme embarque dans son composant (options + available),
   choisit la variante 100x75 DISPONIBLE (en gardant la profondeur deja
   selectionnee quand elle existe), pose l'etat checked, et emet UN SEUL
   evenement change. Si aucune variante 100x75 n'est vendable, elle ne fait
   rien : le defaut du theme vaut mieux qu'une fiche « Unavailable ».
   ========================================================================= */
(function () {
  function lireVariantes(root) {
    var scripts = root.querySelectorAll('script[type="application/json"]');
    for (var i = 0; i < scripts.length; i++) {
      try {
        var d = JSON.parse(scripts[i].textContent);
        if (Array.isArray(d) && d.length && d[0].options) return d;
        if (d && Array.isArray(d.variants)) return d.variants;
      } catch (e) { /* pas ce script */ }
    }
    return null;
  }

  function decode(s) {
    var t = document.createElement('textarea');
    t.innerHTML = s;
    return t.value;
  }

  function act() {
    if (location.search.indexOf('variant=') !== -1) return;
    var root = musaMainVariantRoot();
    if (!root) return;

    var variantes = lireVariantes(root);
    if (!variantes) return;

    var candidates = variantes.filter(function (v) {
      return v.available && v.options.some(function (o) {
        return decode(o).indexOf('100x75') !== -1;
      });
    });
    if (!candidates.length) return;   /* pas de 100x75 vendable : on ne touche a rien */

    /* preferer la variante qui conserve les AUTRES options deja cochees */
    var cochees = [].map.call(
      document.querySelectorAll('.product-form__swatch__input:checked'),
      function (i) { return decode(i.value); });
    var cible = candidates[0];
    for (var i = 0; i < candidates.length; i++) {
      var opts = candidates[i].options.map(decode);
      var communes = cochees.filter(function (v) { return opts.indexOf(v) !== -1; }).length;
      if (communes > (cible.__score || 0)) { cible = candidates[i]; cible.__score = communes; }
    }

    /* poser l'etat sans .click() : checked + UN change final */
    var dernier = null;
    cible.options.forEach(function (opt) {
      var valeur = decode(opt);
      var inputs = document.querySelectorAll('.product-form__swatch__input');
      for (var j = 0; j < inputs.length; j++) {
        if (decode(inputs[j].value) === valeur && !inputs[j].checked) {
          inputs[j].checked = true;
          dernier = inputs[j];
        }
      }
    });
    if (dernier) {
      dernier.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function waitAndAct() {
  if (!/\/products\//.test(location.pathname)) return;
    var tries = 0;
    (function loop() {
      var root = musaMainVariantRoot();
      /* :defined ne suffit pas et 4,5 s non plus sur chargement lent :
         on exige les swatches rendus, et on attend jusqu'a 30 s */
      if (root && root.matches(':defined') &&
          root.querySelector('.product-form__swatch__item')) {
        setTimeout(act, 250); return;
      }
      if (++tries < 200) setTimeout(loop, 150);
    })();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitAndAct);
  } else { waitAndAct(); }
  document.addEventListener('shopify:section:load', waitAndAct);
})();

/* =========================================================================
   MUSA 2 - Date de livraison estimee, juste au-dessus du choix de taille.

   REGLE : seule la PLUS GRANDE taille du produit a un delai long.
     - plus grande taille -> 7 a 15 jours + mention "jusqu'a 20 jours"
     - toutes les autres  -> 5 a 10 jours

   Methode : on ne se fie plus a la position dans le DOM (piegeuse). On calcule
   la plus grande dimension de CHAQUE valeur du groupe de tailles, puis on
   compare la valeur cochee au maximum du groupe. Purement numerique, donc
   insensible a l'ordre des elements et aux doublons du DOM.
     '16x12\" (40x30cm)'   -> 40
     '24x16\" (40x60cm)'   -> 60
     '36x24\" (90x60cm)'   -> 90
     '40x30\" (100x75cm)'  -> 100
     '60x40\" (150x100cm)' -> 150  <- maximum, seul a declencher le delai long
   ========================================================================= */
(function () {
  var STYLE_ID = 'musa-eta-style';
  var BOX_ID = 'musa-eta-box';
  var DIM = /(\d+)\s*[x×]\s*(\d+)/i;
  var NORMAL = { min: 5, max: 10 };
  var XL = { min: 7, max: 15 };

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var css =
      '#' + BOX_ID + '{display:flex;align-items:center;gap:9px;width:100%;' +
      'margin:0 0 16px;padding:10px 12px;box-sizing:border-box;' +
      'border:1px solid #e5e6e5;border-left:3px solid #997a3b;border-radius:8px;' +
      'background:#fafaf7;color:#181818;line-height:1.3;}' +
      '#' + BOX_ID + ' svg{flex:0 0 auto;width:20px;height:20px;stroke:#997a3b;' +
      'fill:none;stroke-width:1.6;stroke-linecap:round;stroke-linejoin:round;}' +
      '#' + BOX_ID + ' .musa-eta-txt{font-size:13px;}' +
      '#' + BOX_ID + ' .musa-eta-txt b{font-weight:800;white-space:nowrap;}' +
      '#' + BOX_ID + ' .musa-eta-sub{display:block;margin-top:1px;font-size:11px;color:#6b6b6b;}';
    var s = document.createElement('style');
    s.id = STYLE_ID; s.textContent = css;
    document.head.appendChild(s);
  }

  function fmt(d) {
    try {
      return d.toLocaleDateString(document.documentElement.lang || 'en-US',
        { month: 'short', day: 'numeric' });
    } catch (e) { return d.toDateString().slice(4, 10); }
  }

  /* plus grande dimension trouvee dans un libelle, 0 si ce n'est pas une taille */
  function dimOf(v) {
    var best = 0;
    var re = /(\d+)\s*[x×]\s*(\d+)/gi;
    var m;
    while ((m = re.exec(v || '')) !== null) {
      var a = parseInt(m[1], 10), b = parseInt(m[2], 10);
      if (a > best) best = a;
      if (b > best) best = b;
    }
    return best;
  }

  /* true seulement si la valeur cochee est la plus grande du groupe de tailles */
  function largestSelected(root) {
    var maxAll = 0, maxSel = 0, found = false;

    var inputs = root.querySelectorAll('.product-form__swatch__input');
    for (var i = 0; i < inputs.length; i++) {
      var d = dimOf(inputs[i].value);
      if (!d) continue;
      found = true;
      if (d > maxAll) maxAll = d;
      if (inputs[i].checked && d > maxSel) maxSel = d;
    }

    var selects = root.querySelectorAll('select.single-option-selector');
    for (var s = 0; s < selects.length; s++) {
      var sel = selects[s];
      for (var o = 0; o < sel.options.length; o++) {
        var dd = dimOf(sel.options[o].value);
        if (!dd) continue;
        found = true;
        if (dd > maxAll) maxAll = dd;
        if (o === sel.selectedIndex && dd > maxSel) maxSel = dd;
      }
    }

    return found && maxAll > 0 && maxSel === maxAll;
  }

  function render(box, root) {
    var xl = largestSelected(root);
    var win = xl ? XL : NORMAL;
    var now = new Date();
    var from = new Date(now.getTime() + win.min * 86400000);
    var to = new Date(now.getTime() + win.max * 86400000);
    var sub = xl
      ? 'Largest size - can take up to 20 days in busy periods'
      : 'Free worldwide shipping on every order';
    box.innerHTML =
      '<svg viewBox="0 0 24 24" aria-hidden="true">' +
      '<path d="M1 3h13v13H1z"/><path d="M14 8h4l3 3v5h-7z"/>' +
      '<circle cx="5.5" cy="18.5" r="2.5"/><circle cx="17.5" cy="18.5" r="2.5"/>' +
      '</svg>' +
      '<span class="musa-eta-txt">Estimated delivery <b>' +
      fmt(from) + ' - ' + fmt(to) + '</b>' +
      '<span class="musa-eta-sub">' + sub + '</span>' +
      '</span>';
  }

  function build() {
    var root = musaMainVariantRoot();
    if (!root) return false;
    var box = document.getElementById(BOX_ID);
    if (!box) {
      box = document.createElement('div');
      box.id = BOX_ID;
      root.insertAdjacentElement('beforebegin', box);
      root.addEventListener('change', function () { render(box, root); });
      root.addEventListener('click', function () { setTimeout(function () { render(box, root); }, 40); });
    }
    render(box, root);
    return true;
  }

  function waitAndBuild() {
  if (!/\/products\//.test(location.pathname)) return;
    if (!document.body || document.body.className.indexOf('template-product') === -1) return;
    injectStyle();
    var tries = 0;
    (function loop() {
      if (build()) return;
      if (++tries < 30) setTimeout(loop, 200);
    })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitAndBuild);
  } else { waitAndBuild(); }
  document.addEventListener('shopify:section:load', waitAndBuild);
})();


/* =========================================================================
   MUSA 3 - Cartes de taille (visuel du codeur, reproduit a l'identique)

   Reference : theme « Copy of Venue - Optimized -V1 » (192849871194). Le codeur
   avait mis ce visuel en inline dans son template ; on le reproduit ici en
   décorant les swatches par JS, memes classes et memes valeurs CSS :
     - carte 86x82, bord #e5e6e5, fond #fafaf7, rayon 12px
     - selection : bord #181818, fond #f5f5f2
     - badges : 100x75 -> « Most Popular » (bleu), 150x100 -> « Best Value » (vert)

   Difference volontaire : la selection passe par le CSS `:checked + label`
   plutot que par une classe togglee en JS — le theme remplace les noeuds a
   chaque changement de variante, une classe posee en JS se perdait.
   ========================================================================= */
(function () {
  var CSS = [
    '.product-form__swatch__item--button{display:inline-block;margin:0 8px 12px 0;vertical-align:top}',
    '.product-form__swatch__label.custom-size-box{display:flex;flex-direction:column;align-items:center;',
    'justify-content:center;min-width:86px;width:auto;min-height:76px;height:auto;padding:8px 12px;border:2px solid #e5e6e5;border-radius:12px;',
    'background:#fafaf7;font-weight:700;font-size:14px;color:#181818;cursor:pointer;text-align:center;',
    'box-sizing:border-box;transition:border-color .2s,background .2s;position:relative;padding:6px 2px}',
    '.product-form__swatch__item--button input.product-form__swatch__input[type=\"radio\"]:checked+label.custom-size-box,',
    '.product-form__swatch__label.custom-size-box--selected{border-color:#181818;background:#f5f5f2}',
    '.custom-size-badge{margin-bottom:2px;background:#e0edfc;color:#0656b7;border-radius:5px;',
    'font-size:8px;font-weight:700;text-transform:uppercase;padding:2px 5px;letter-spacing:.02em;display:inline-block}',
    '.custom-size-badge--popular{background:#e0edfc;color:#0656b7}',
    '.custom-size-badge--value{background:#d3f3d6;color:#0c7d34}',
    '.custom-size-title{margin:0;font-size:13px;font-weight:800;line-height:1.1;display:block}',
    '.custom-size-details{font-size:10px;line-height:1.1;color:#181818;margin:0}',
    /* Mobile : 3 cartes par rangee, pleine largeur — les cartes 86px etaient
       trop etroites et les badges debordaient (retour marchand, 31/07). */
    '@media (max-width:749px){',
    '.product-form__swatch__item--button{width:calc(33.33% - 6px);margin:0 6px 10px 0}',
    '.product-form__swatch__label.custom-size-box{width:100%;min-width:0;padding:8px 4px}',
    '.custom-size-badge{font-size:9px;letter-spacing:0}',
    '.custom-size-title{font-size:12.5px}',
    '}'
  ].join('');

  function injectCss() {
    if (document.getElementById('musa-size-cards-css')) return;
    var st = document.createElement('style');
    st.id = 'musa-size-cards-css';
    st.textContent = CSS;
    document.head.appendChild(st);
  }

  function badgeFor(value) {
    if (value.indexOf('100x75') !== -1) return ['custom-size-badge--popular', 'Most Popular'];
    if (value.indexOf('150x100') !== -1) return ['custom-size-badge--value', 'Best Value'];
    return null;
  }

  function decorate() {
    injectCss();
    var items = document.querySelectorAll('.product-form__swatch__item');
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var label = item.querySelector('.product-form__swatch__label');
      /* garde robuste : la classe peut survivre a un re-rendu partiel, les
         spans non — on teste donc la STRUCTURE, pas la classe */
      if (!label || label.querySelector('.custom-size-title')) continue;
      var input = item.querySelector('.product-form__swatch__input');
      if (!input || item.querySelector('img, .swatch--color')) continue;
      label.classList.add('custom-size-box');

      /* le theme rend deja « Most Popular » / « Best Value » en texte dans le
         label (ancien code serveur) : on retire ces mots, notre badge les
         reposera proprement — sinon ils se retrouvaient DANS le titre */
      var texte = label.textContent.replace(/Most Popular|Best Value/g, '').trim();
      label.textContent = '';

      var value = item.getAttribute('data-value') || input.value || texte;
      var b = badgeFor(value);
      if (b) {
        var badge = document.createElement('span');
        badge.className = 'custom-size-badge ' + b[0];
        badge.textContent = b[1];
        label.appendChild(badge);
      }

      /* Deux lignes, comme l'ancien theme : la taille en gros, la parenthese
         en petit dessous (.custom-size-details, 10px). Tout sur une ligne a
         13px/800 debordait de la carte des qu'il y avait un badge. */
      var m = texte.match(/^([^(]+?)\s*(\(.+\))?$/);
      var t = document.createElement('span');
      t.className = 'custom-size-title';
      t.textContent = (m && m[1] ? m[1] : texte).trim();
      label.appendChild(t);
      if (m && m[2]) {
        var d = document.createElement('span');
        d.className = 'custom-size-details';
        d.textContent = m[2];
        label.appendChild(d);
      }
    }
  }

  var timer = null;
  function replanifier() {
    /* anti-rebond : le theme emet des rafales de mutations au changement de variante */
    clearTimeout(timer);
    timer = setTimeout(decorate, 80);
  }

  function arm() {
  if (!/\/products\//.test(location.pathname)) return;
    decorate();
    /* ⚠ Le theme REMPLACE le noeud variant-radios a chaque changement de
       variante : un observateur pose sur ce noeud meurt avec lui et la
       decoration disparait au premier clic. On observe donc le body, qui
       lui survit, et on ne redecore que s'il reste des labels nus. */
    if (window.MutationObserver && !document.body.__musaCards) {
      document.body.__musaCards = true;
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var t = muts[i].target;
          if (t && t.nodeType === 1 &&
              (t.closest ? t.closest('product-form, variant-radios, variant-selects, variant-mixed-inputs, .product-form') : null)) {
            replanifier();
            return;
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arm);
  } else { arm(); }
  document.addEventListener('shopify:section:load', arm);
})();
